import React from 'react'
import entreprisepart1_1 from '../images/entreprisepart1_1.jpg'
import entreprisepart1_2 from '../images/entreprisepart1_2.jpg'
import entreprisepart1_3 from '../images/entreprisepart1_3.jpg'
import entreprisepart1_4 from '../images/entreprisepart1_4.jpg'
import entreprisepart3_1 from '../images/entreprisepart3_1.jpg'
import entreprisepart3_2 from '../images/entreprisepart3_2.jpg'
import entreprisepart3_3 from '../images/entreprisepart3_3.jpg'
import tick from '../images/tick_2.png'
import mission from '../images/mission_blanc.png'
import value from '../images/value_blanc.png'
import vision from '../images/vision_blanc.png'
import { Pagination, Autoplay, FreeMode } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { useLang } from "./Provider/LanguageProvider";

function NotreEntreprise() {
  const { language } = useLang();

  return (
    <div id='notrentreprise'>
      <div className='gap-entreprise'></div>
      <section className='section1'>
        <div className='welcome'>
          <span className='pre-title'>{language === 'fr' ? 'A PROPOS DE' : 'ABOUT'}</span>
          <h1>{language === 'fr' ? 'NOTRE ENTREPRISE' : 'OUR COMPANY'}</h1>
        </div>
      </section>
      <section className='section2' id="notrehistoire">
        <div className='container'>
          <div className='img-cont' data-aos="zoom-in-right">
            <Swiper
              className='pic-cont'
              modules={[Pagination, FreeMode, Autoplay]}
              slidesPerView={1}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false
              }}
            >
              <SwiperSlide className='pic'>
                <img src={entreprisepart1_1} alt='histoire pic' />
              </SwiperSlide>
              <SwiperSlide className='pic'>
                <img src={entreprisepart1_2} alt='histoire pic' />
              </SwiperSlide>
              <SwiperSlide className='pic'>
                <img src={entreprisepart1_3} alt='histoire pic' />
              </SwiperSlide>
              <SwiperSlide className='pic'>
                <img src={entreprisepart1_4} alt='histoire pic' />
              </SwiperSlide>
            </Swiper>
          </div>
          {language === 'fr' ?
            <div className='text-cont' data-aos="zoom-in-left">
              <div className='h3'>
                <div className='line'></div><h3>NOTRE HISTOIRE</h3>
              </div>
              <h2>DEPUIS 1995</h2>
              <p>
                Shenimed est l’un des principaux distributeurs de cigarettes en République
                Démocratique du Congo (RDC). Le partenariat exclusif avec Japan Tobacco
                International (JTI) a permis à Shenimed de distribuer leurs marques. La société s’est rapidement développée,
                devenant un acteur majeur de la distribution de cigarettes en RDC.
                <br />
                <br />
                Aujourd’hui, Shenimed gère un vaste réseau de distribution couvrant tout
                le pays avec 20 agences, 27 entrepôts secondaires, et plus de 40 points de
                vente dans 17 provinces. L’entreprise dessert des régions reculées grâce
                à une logistique bien rodée, incluant divers moyens de transport tels que
                camions, avions, motos et bateaux.
              </p>
              <div className='links'>
                <a href='/nosmarques'>NOS MARQUES →</a>
              </div>
            </div> :
            <div className='text-cont' data-aos="zoom-in-left">
              <div className='h3'>
                <div className='line'></div><h3>OUR HISTORY</h3>
              </div>
              <h2>SINCE 1995</h2>
              <p>
                Shenimed is one of the leading distributors of cigarettes in the Democratic
                Republic of Congo (DRC). The exclusive partnership with Japan Tobacco
                International (JTI) has enabled Shenimed to distribute their brands. The company quickly grew,
                becoming a major player in the distribution of cigarettes in the DRC.
                <br />
                <br />
                Today, Shenimed manages a vast distribution network covering the entire
                country with 20 agencies, 27 secondary warehouses, and over 40 sales points
                in 17 provinces. The company serves remote regions thanks
                to a well-organized logistics network, including various means of transport such as
                trucks, airplanes, motorcycles, and boats.
              </p>
              <div className='links'>
                <a href='/nosmarques'>OUR BRANDS →</a>
              </div>
            </div>
          }
        </div>
      </section>
      <section className='section3' id="mission">
        {language === 'fr' ?
          <div className='container'>
            <div className='item vision'>
              <div className='img-cont' data-aos="flip-left">
                <img src={vision} alt='vision' />
              </div>
              <h2>NOTRE VISION</h2>
              <span>
                Accroître les parts de
                marché et créer davantage
                d’emplois en RDC tout en
                respectant les cadres
                légaux du pays.
              </span>
            </div>
            <div className='item valeur'>
              <div className='img-cont' data-aos="flip-left">
                <img src={mission} alt='mission' />
              </div>
              <h2>NOTRE MISSION</h2>
              <span>
                Rester leader dans la
                distribution de tabac tout
                en optimisant ses opérations
                pour plus d’efficacité
                et de professionnalisme.
              </span>
            </div>
            <div className='item defis'>
              <div className='img-cont' data-aos="flip-left">
                <img src={value} alt='values' />
              </div>
              <h2>NOS VALEURS</h2>
              <ul>
                <li><img src={tick} className='v' alt='blue tick' />Excellence</li>
                <li><img src={tick} className='v' alt='blue tick' />Humilité</li>
                <li><img src={tick} className='v' alt='blue tick' />Persévérance</li>
                <li><img src={tick} className='v' alt='blue tick' />Efficacité</li>
                <li><img src={tick} className='v' alt='blue tick' />Professionnalisme</li>
              </ul>
            </div>
          </div> :
          <div className='container'>
            <div className='item vision'>
              <div className='img-cont' data-aos="flip-left">
                <img src={vision} alt='vision' />
              </div>
              <h2>OUR VISION</h2>
              <span>
                Increase market share and create
                more jobs in the DRC while respecting
                the country's legal frameworks.
              </span>
            </div>
            <div className='item valeur'>
              <div className='img-cont' data-aos="flip-left">
                <img src={mission} alt='mission' />
              </div>
              <h2>OUR MISSION</h2>
              <span>
                Remain the leader in tobacco
                distribution while optimizing
                operations for greater efficiency
                and professionalism.
              </span>
            </div>
            <div className='item defis'>
              <div className='img-cont' data-aos="flip-left">
                <img src={value} alt='values' />
              </div>
              <h2>OUR VALUES</h2>
              <ul>
                <li><img src={tick} className='v' alt='blue tick' />Excellence</li>
                <li><img src={tick} className='v' alt='blue tick' />Humility</li>
                <li><img src={tick} className='v' alt='blue tick' />Perseverance</li>
                <li><img src={tick} className='v' alt='blue tick' />Efficiency</li>
                <li><img src={tick} className='v' alt='blue tick' />Professionalism</li>
              </ul>
            </div>
          </div>

        }
      </section>
      <section className='section4' id="defis">
        <div className='container'>
          {language === 'fr' ?
            <div className='text-cont' data-aos="zoom-in-right">
              <div className='h3'>
                <div className='line'></div><h3>DÉFIS ET OPPORTUNITÉS</h3>
              </div>
              <h2>PLUS DE 1000
                ACTEURS ENGAGÉS</h2>
              <p>
                Shenimed emploie plus de 360 agents directement et environ 1 000 autres
                employé de manière indirecte à travers son réseau de distribution. L’entreprise
                s’engage à maintenir une croissance continue tout en respectant les
                lois et en adoptant une approche responsable suivant la réglementation du
                pays.
              </p>
              <h2>NOUS NOUS ADAPTONS
                À L’ENVIRONNEMENT ET
                AUX DÉFIS DU MARCHÉ</h2>
              <p>
                Les défis logistiques en RDC, notamment en termes d’infrastructures routières
                et sécuritaires dans certaines régions, ne freinent pas la détermination
                de Shenimed à assurer une distribution efficace. Malgré la taxation
                élevée, l’entreprise continue de s’adapter aux conditions locales et aux défis
                du marché.
              </p>
            </div> :
            <div className='text-cont' data-aos="zoom-in-right">
              <div className='h3'>
                <div className='line'></div><h3>CHALLENGES AND OPPORTUNITIES</h3>
              </div>
              <h2>MORE THAN 1000
                COMMITTED ACTORS</h2>
              <p>
                Shenimed directly employs over 360 agents and approximately 1,000 others
                indirectly through its distribution network. The company is committed to maintaining
                continuous growth while respecting the laws and adopting a responsible
                approach in line with the country's regulations.
              </p>
              <h2>WE ADAPT TO THE
                ENVIRONMENT AND
                MARKET CHALLENGES</h2>
              <p>
                The logistical challenges in the DRC, particularly in terms of road
                infrastructure and security in certain regions, do not deter Shenimed’s
                determination to ensure efficient distribution. Despite high taxation, the
                company continues to adapt to local conditions and market challenges.
              </p>
            </div>
          }
          <div className='img-cont' data-aos="zoom-in-left">
            <Swiper
              className='pic-cont'
              modules={[Pagination, FreeMode, Autoplay]}
              slidesPerView='1'
              autoplay={{
                delay: 4000,
                disableOnInteraction: false
              }}
            >
              <SwiperSlide className='pic'>
                <img src={entreprisepart3_1} alt='defis pic' />
              </SwiperSlide>
              <SwiperSlide className='pic'>
                <img src={entreprisepart3_2} alt='defis pic' />
              </SwiperSlide>
              <SwiperSlide className='pic'>
                <img src={entreprisepart3_3} alt='defis pic' />
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </section>
    </div>
  )
}

export default NotreEntreprise